// @ts-check
import Popup from "Components/Common/popup";
import 'Styles/commonComponents/settings/settingsBlock.scss';
import IconsContainer from "Utils/IconsContainer";
import { observer } from "mobx-react";
import React from 'react';

/**
 * @param {{
* id?: string,
* className?: string,
* title: React.JSX.Element | string,
* helperText?: string,
* onTitleClick?: (arg: React.MouseEvent<HTMLDivElement, MouseEvent>) => void,
* children: React.JSX.Element | React.JSX.Element[]
* }} props 
* @returns {React.JSX.Element}
*/
const SettingsBlock = (props) =>
    <div
        id={props.id}
        className={'settings-block ' + (props.className ? props.className : '')}>
        <div
            className="settings-block-title"
            onClick={e => {
                if (props.onTitleClick)
                    props.onTitleClick(e);
            }}>
            {props.title}
            {(props.helperText ?
                <Popup
                    popupText={props.helperText}
                    className='fast-info-popup'>
                    {IconsContainer.Get('ci-info')}
                </Popup> : '')}
        </div>
        <div
            className="settings-block-items">
            {props.children}
        </div>
    </div>

export default observer(SettingsBlock);